import { Button, Col, Form, Input, Modal, Row, Select, notification } from "antd";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimezoneSelect from "react-timezone-select";


import emojiData from "@emoji-mart/data";
import {
  AttachmentIcon,
  ContactCreatedIcon,
  FirstMessageIcon
} from "../../../../assets/svg";
import { EditableText } from "../../../../components";
import { useModal } from "../../../../hook/useModal";
import { clearEmptyField } from "../../../../utils";
import {
  DAY_OF_WEEK_TYPE,
  DELAY_TYPE,
  DURATION_TYPE,
  MONTH_TYPE,
} from "../../../../utils/constants";
import Action from "../Action";
import { EmojiPicker, UploadFileModal } from "./../../../../components";

import "./styles.less";

const ActionModal = ({ visible, handleOk, handleCancel, data, index }) => {
  const [actionType, setActionType] = useState("");
  const [attachment, setAttachmentUrl] = useState({});
  const [form] = Form.useForm();

  // TODO: move to form
  const [duration, setDuration] = useState(DELAY_TYPE[0].value);
  const [datetime, setDatetime] = useState(new Date());

  const [dayOfMonth, setDayOfMonth] = useState(1);
  const [month, setMonthState] = useState(MONTH_TYPE[0].value);

  const [dayOfWeek, setDayOfWeek] = useState(DAY_OF_WEEK_TYPE[0].value);

  const [time, setTime] = useState(setHours(setMinutes(new Date(), 30), 16));


  const [days, setDaysState] = useState(0);
  const [hours, setHoursState] = useState(0);
  const [minutes, setMinutesState] = useState(0);
  const [seconds, setSecondsState] = useState(0);
  const [defaultValueMessage, setDefaultValueMessage] = useState("");
  const [message, setMessage] = useState(data?.message || "");
  const [selectedTimezone, setSelectedTimezone] = useState({});
  const [wordLimit, setWordLimit] = useState(160);
  const childRef = useRef();


  const {
    close: closeUpload,
    show: showUpload,
    visible: visibleUpload,
  } = useModal();
  const [showEmoji, setShowEmoji] = useState(false);
  const handleSelectAction = (value) => {
    setActionType(value);
  };

  const changeEmoji = (value) => {
    const words = value.split(" ");
    const wordsWithEmojis = words.map((word) => {
      if (word.startsWith(":") && word.endsWith(":")) {
        const emojiKeyword = word.slice(1, -1);
        const emoji = emojiData.emojis[emojiKeyword]?.skins?.[0]?.native;
  
        if (emoji) {
          return emoji;
        }

      }
  
      return word;
    });

    // Join the words back into a string
    let message = wordsWithEmojis.join(" ");
    return message;
  }

  const hanldeChangeMessage = (messageValue) => {
    const msg = changeEmoji(messageValue)
    setMessage(msg);
  };

  const handleResetActionType = () => {
    setActionType("");
  };

  const handleSubmitSendMessage = (values) => {
    handleOk(data, index, {
      type: actionType,
      message: message,
      fileAttached: attachment,
      delay: null,
    });
  };

  const handleSubmitDelay = () => {
    let d = days, h = hours, m = minutes, s = seconds;
    let delay = {};
    if (duration === DURATION_TYPE.TIME_FROM_TRIGGER) {
      if(!d && !h && !m && !s) {
        notification.error({
          title: "Action failed",
          message: `Please fill in at least one field`,
        });
        return;
      } else {
        if (!d) d = 0;
        if (!h) h = 0;
        if (!m) m = 0;
        if (!s) s = 0;
      }
      delay = {
        days: parseInt(d) || null,
        hours: parseInt(h) || null,
        minutes: parseInt(m) || null,
        seconds: parseInt(s) || null,
      };
    } else if (duration === DURATION_TYPE.UNTIL_NEXT_DAY) {
      if(!time || JSON.stringify(selectedTimezone) == JSON.stringify({}) ) {
        notification.error({
          title: "Action failed",
          message: `Please fill all the fields`,
        });
        return
      }
      delay = {
        time: time || null,
        timezone: selectedTimezone || null,
      };
    } else if (duration === DURATION_TYPE.UNTIL_NEXT_DAY_OF_WEEK) {
      if(!time || !dayOfWeek || JSON.stringify(selectedTimezone) == JSON.stringify({}) ) {
        notification.error({
          title: "Action failed",
          message: `Please fill all the fields`,
        });
        return
      }
      delay = {
        dayOfWeek: dayOfWeek || null,
        time: time || null,
        timezone: selectedTimezone || null,
      };
    } else if (duration === DURATION_TYPE.UNTIL_NEXT_DAY_OF_MONTH) {
      if(!time || !dayOfMonth || month || JSON.stringify(selectedTimezone) == JSON.stringify({}) ) {
        notification.error({
          title: "Action failed",
          message: `Please fill all the fields`,
        });
        return
      }
      delay = {
        dayOfMonth: dayOfMonth || null,
        month: month || null,
        time: time || null,
        timezone: selectedTimezone || null,
      };
    } else if (duration === DURATION_TYPE.UNTIL_DATE) {
      if(!datetime) {
        notification.error({
          title: "Action failed",
          message: `Please fill all the fields`,
        });
        return
      }
      delay = {
        datetime: datetime || null,
      };
    }
    const newData = {
      type: actionType,
      delay: clearEmptyField({
        duration: duration,
        ...delay,
      }),
    };
    handleOk(data, index, newData);
  };

  const handleUploadFile = (value) => {
    setAttachmentUrl(value);
    closeUpload();
  };

  const handleChangeEmoji = (emojiObj) => {
    // childRef.current.triggerUpdateText(emojiObj.native);
    setMessage(`${message}` + `${emojiObj.native}`)
    if (wordLimit === 2) {
      setWordLimit(160);
    } else if (wordLimit === 1) {
      setWordLimit(159);
    } else {
      setWordLimit(wordLimit - 2);
    }
    setShowEmoji(false);
  };

  const handleSelectTimeZome = (e) => {
    setSelectedTimezone(e);
  };

  useEffect(() => {
    setMessage(data?.message || "");
    setDefaultValueMessage(data?.message || "");
  }, [data]);


  const renderDelayContent = () => {
    if (duration === DURATION_TYPE.TIME_FROM_TRIGGER) {
      return (
        <Row gutter={24}>
          <Col sm={12}>
            <label>Days</label>
            <Input
              value={days}
              onChange={(e) => {
                setDaysState(e.target.value);
              }}
              type="number"
              min={0}
              max={31}
            />
          </Col>
          <Col sm={12}>
            <label>Hours</label>
            <Input
              value={hours}
              onChange={(e) => {
                setHoursState(e.target.value);
              }}
              type="number"
              min={0}
              max={23}
            />
          </Col>
          <Col sm={12}>
            <label>Minutes</label>
            <Input
              value={minutes}
              onChange={(e) => {
                setMinutesState(e.target.value);
              }}
              type="number"
              min={0}
              max={59}
            />
          </Col>
          <Col sm={12}>
            <label>Seconds</label>
            <Input
              value={seconds}
              onChange={(e) => {
                setSecondsState(e.target.value);
              }}
              type="number"
              min={0}
              max={59}
            />
          </Col>
        </Row>
      );
    }
    if (duration === DURATION_TYPE.UNTIL_NEXT_DAY) {
      return (
        <>
          <div>
            <label>TIME</label>
            <DatePicker
              selected={time}
              onChange={(date) => setTime(date)}
              // dateFormat="MMMM d, yyyy h:mm aa"
              timeFormat="HH:mm aa"
              timeIntervals={15}
              dateFormat="h:mm aa"
              showTimeSelectOnly
              showTimeSelect
            />
          </div>
          <div>
            <label>TIMEZONE</label>
            <TimezoneSelect
              value={selectedTimezone}
              onChange={handleSelectTimeZome}
            />
          </div>
        </>
      );
    }
    if (duration === DURATION_TYPE.UNTIL_NEXT_DAY_OF_WEEK) {
      return (
        <>
          <div>
            <label>Day Of Week</label>
            <Select value={dayOfWeek} onChange={setDayOfWeek}>
              {DAY_OF_WEEK_TYPE.map((item) => (
                <Select.Option value={item.value}>{item.label}</Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>TIME</label>
            <DatePicker
              selected={time}
              onChange={(date) => setTime(date)}
              // dateFormat="MMMM d, yyyy h:mm aa"
              timeFormat="HH:mm aa"
              timeIntervals={15}
              dateFormat="h:mm aa"
              showTimeSelectOnly
              showTimeSelect
            />
          </div>
          <div>
            <label>TIMEZONE</label>
            <TimezoneSelect
              value={selectedTimezone}
              onChange={setSelectedTimezone}
            />
          </div>
        </>
      );
    }
    if (duration === DURATION_TYPE.UNTIL_NEXT_DAY_OF_MONTH) {
      return (
        <>
          <Row>
            <Col>
              <label>Day Of Month</label>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              {/* TODO: refactor this one */}
              <Input
                max={31}
                min={1}
                value={dayOfMonth}
                onChange={(e) => {
                  setDayOfMonth(e.target.value);
                }}
              />
            </Col>
            <Col sm={12}>
              <label></label>
              <Select value={month} onChange={setMonthState}>
                {MONTH_TYPE.map((item) => (
                  <Select.Option value={item.value}>{item.label}</Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <div>
            <label>TIME</label>
            <DatePicker
              selected={time}
              onChange={(date) => setTime(date)}
              // dateFormat="MMMM d, yyyy h:mm aa"
              timeFormat="HH:mm aa"
              timeIntervals={15}
              dateFormat="h:mm aa"
              showTimeSelectOnly
              showTimeSelect
            />
          </div>
          <div>
            <label>TIMEZONE</label>
            <TimezoneSelect
              value={selectedTimezone}
              onChange={setSelectedTimezone}
            />
          </div>
        </>
      );
    }
    // UNTIL_DATE
    return (
      <div>
        <label>DATE / TIME</label>
        <DatePicker
          showTimeSelect
          timeIntervals={5}
          selected={datetime}
          onChange={(date) => setDatetime(date)}
          dateFormat="MMMM d, yyyy h:mm aa"
        />
      </div>
    );
  };

  useEffect(() => {
    // setMessage("");
    if (!data) {
      setActionType("");
      setAttachmentUrl({});
      form.setFieldsValue({
        message: "",
      });
      setDuration(DELAY_TYPE[0].value);
      setDatetime(new Date());
      setDayOfMonth(1);
      setMonthState(MONTH_TYPE[0].value);
      setDayOfWeek(DAY_OF_WEEK_TYPE[0].value);
      setTime(setHours(setMinutes(new Date(), 30), 16));
      setDaysState("");
      setHoursState("");
      setMinutesState("");
      setSecondsState("");

      setSelectedTimezone({});
    } else {
      setActionType(data.type);
      setAttachmentUrl(data.fileAttached);
      form.setFieldsValue({
        message: data.message,
      });

      if (data.type === "DELAY") {
        setDuration(data.delay?.duration || DELAY_TYPE[0].value);
        setDatetime(
          data.delay?.datetime ? new Date(data.delay?.datetime) : new Date()
        );
        setDayOfMonth(data.delay?.dayOfMonth || 1);
        setMonthState(data.delay?.month || MONTH_TYPE[0].value);
        setDayOfWeek(data.delay?.dayOfWeek || DAY_OF_WEEK_TYPE[0].value);
        setTime(
          data.delay?.time
            ? new Date(data.delay?.time)
            : setHours(setMinutes(new Date(), 30), 16)
        );
        setDaysState(data.delay?.days || "");
        setHoursState(data.delay?.hours || "");
        setMinutesState(data.delay?.minutes || "");
        setSecondsState(data.delay?.seconds || "");
        setSelectedTimezone(data.delay?.timezone || data.delay?.timeZone || {});
      }
    }
  }, [visible, data]);
  return (
    <>
      <Modal
        key="TriggerModal"
        visible={visible}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={true}
        destroyOnClose={true}
        centered
        className="automation-trigger-modal"
      >
        <h3 className="font-bold text-center text-2xl mb-9">Select Action</h3>
        <p className="text-center">
          Actions are the building blocks of your automation
        </p>
        {actionType === "DELAY" ? (
          <div className="action-detail-wrap delay-wrap">
            <div className="flex justify-between items-center action-detail-input">
              <span>Delay</span>
              <button
                className="text-primary px-3 py-1"
                onClick={handleResetActionType}
              >
                Change
              </button>
            </div>
            <label>Duration</label>
            <Select value={duration} onChange={setDuration} require>
              {DELAY_TYPE.map((item) => (
                <Select.Option value={item.value}>{item.label}</Select.Option>
              ))}
            </Select>
            <div className="delay-content-wrap">{renderDelayContent()}</div>
            <Row justify="space-around" className="mt-12">
              <Col>
                <Button
                  className="md:min-w-200 ml-5"
                  type="primary"
                  size="large"
                  onClick={handleCancel}
                  block
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  className="md:min-w-200 ml-5"
                  type="primary"
                  size="large"
                  onClick={handleSubmitDelay}
                  block
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
        ) : actionType ? (
          <div className="action-detail-wrap">
            <div className="flex justify-between items-center action-detail-input">
              <span>Send Message</span>
              <button
                className="text-primary px-3 py-1 automation-trigger-modal-"
                onClick={handleResetActionType}
              >
                Change
              </button>
            </div>
            <Form
              form={form}
              name="control-hooks"
              onFinish={handleSubmitSendMessage}
              className=""
            >
              <div className="sendmessage-textarea-wrap">
                <EditableText
                  defaultValue={defaultValueMessage}
                  onChange={hanldeChangeMessage}
                  ref={childRef}
                  isFormEnable
                  setValue={setMessage}
                  value={message}
                  wordLimit={wordLimit}
                  setWordLimit={setWordLimit}
                />
                <div className="textarea-actions"> 
                  <AttachmentIcon onClick={showUpload} />
                  <EmojiPicker onEmojiSelect={handleChangeEmoji} />
                  <UploadFileModal
                    visible={visibleUpload}
                    handleOk={handleUploadFile}
                    handleCancel={closeUpload}
                  />
                </div>
              </div>
              {attachment?.name && <b>{attachment?.name}</b>}
              <Row justify="end" className="mt-12">
                <Col>
                  <Form.Item noStyle>
                    <Button
                      className="md:min-w-200"
                      type="text"
                      size="large"
                      onClick={handleResetActionType}
                    >
                      Cancel
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item noStyle shouldUpdate>
                    <Button
                      className="md:min-w-200 ml-5"
                      type="primary"
                      size="large"
                      htmlType="submit"
                      block
                    >
                      Save
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        ) : (
          <Row justify="center" className="mt-12" gutters={16}>
            <Col className="mx-4">
              <Action
                Icon={FirstMessageIcon}
                label="Send Message"
                value="ACTION"
                onClick={handleSelectAction}
              />
            </Col>
            <Col className="mx-4">
              <Action
                Icon={ContactCreatedIcon}
                label="Delay"
                value="DELAY"
                onClick={handleSelectAction}
              />
            </Col>
          </Row>
        )}
      </Modal>
    </>
  );
};

export default ActionModal;
